<nx-accordion variant="light">
    <nx-expansion-panel expanded="[true]">
        <nx-expansion-panel-header>
            <nx-expansion-panel-title style="font-weight: 600;">Vehicles Details</nx-expansion-panel-title>
        </nx-expansion-panel-header>

        <div [formGroup]="vehicleDetailForm">
            <div nxLayout="grid nopadding">
                <div nxRow>

                    <div nxCol="12,12,6,6,6,6,6">
                        <nx-formfield label="{{ 'COVERAGE.FIELD.VEHICLE_NO' | translate }}">
                            <input nxInput formControlName="vehicleNo" (blur)="checkVehicleNo()" maxlength="20" appToUpperCase />
                            <nx-error nxFormfieldError *ngIf="vehicleDetailForm.get('vehicleNo').hasError('required')">
                                <strong>Please enter the Vehicle No.</strong>
                            </nx-error>
                            <nx-error nxFormfieldError *ngIf="vehicleDetailForm.get('vehicleNo').hasError('invalidRed')">
                                <strong>Vehicle No. is Invalid.</strong>
                            </nx-error>
                        </nx-formfield>
                    </div>

                    <div nxCol="12,12,6,6,6,6,6">
                        <nx-formfield *ngIf="isAmendDateScren" label="{{ 'COVERAGE.FIELD.YEAR_OF_MANUFACTURE' | translate }}">
                            <input nxInput formControlName="vehicleMakeYear" appToUpperCase />
                        </nx-formfield>
                    </div>

                    <div nxCol="12" *ngIf="isAmendDateScren">
                        <nx-formfield label="{{ 'COVERAGE.FIELD.MAKE_MODEL' | translate }}">
                            <input nxInput formControlName="vehModelNvicDesc" appToUpperCase />
                            <span nxFormfieldSuffix>
                                <nx-icon aria-hidden="true" name="search"></nx-icon>
                            </span>
                        </nx-formfield>
                    </div>

                    <div nxCol="12,12,6,6,6,6,6">
                        <nx-formfield label="{{ 'COVERAGE.FIELD.ENGINE_MOTOR_NO' | translate }}">
                            <input nxInput formControlName="vehicleEngine" maxlength="60" appToUpperCase />
                            <nx-error nxFormfieldError
                                *ngIf="vehicleDetailForm.get('vehicleEngine').hasError('required')">
                                <strong>Please enter the Engine/Motor No.</strong>
                            </nx-error>
                        </nx-formfield>
                    </div>

                    <div nxCol="12,12,6,6,6,6,6">
                        <nx-formfield label="{{ 'COVERAGE.FIELD.CHASSIS_NO' | translate }}">
                            <input nxInput formControlName="vehicleChassis" maxlength="60" appToUpperCase />
                            <nx-error nxFormfieldError
                                *ngIf="vehicleDetailForm.get('vehicleChassis').hasError('required')">
                                <strong>Please enter the Chassis No.</strong>
                            </nx-error>
                        </nx-formfield>
                    </div>

                    <div nxCol="12,12,6,6,6,6,6">
                        <nx-formfield label="JPJ Effective Date">
                            <input nxDatefield nxInput [datepicker]="myDatepicker" formControlName="jpjEffectiveDate" (dateChange)="onDateChange($event)" />
                            <!-- <input nxDatefield nxInput strict="false" [parseFormat]="'DD/MM/YYYY'" displayFormat="DD/MM/YYYY"
                                [datepicker]="myDatepicker" formControlName="jpjEffectiveDate" #nonStrictDatefield="nxDatefield"
                                (dateChange)="onDateChange($event)" /> -->

                            <span nxFormfieldHint>{{ 'GLOBAL.DATE.DD/MM/YYYY' | translate }}</span>
                            <nx-datepicker-toggle [for]="myDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
                            <nx-datepicker #myDatepicker></nx-datepicker>
                            <nx-error nxFormfieldError *ngIf="vehicleDetailForm && vehicleDetailForm.get('jpjEffectiveDate').hasError('required')">
                            <strong>Please enter an JPJ Effective Date.</strong>
                            </nx-error>
                        </nx-formfield>
                    </div>

                    <div nxCol="12,12,6,6,6,6,6">
                        <nx-formfield label="JPJ Expiry Date">
                            <input nxDatefield nxInput [datepicker]="myDatepicker2" formControlName="jpjExpiryDate" />
                            <span nxFormfieldHint>{{ 'GLOBAL.DATE.DD/MM/YYYY' | translate }}</span>
                            <nx-datepicker-toggle [for]="myDatepicker2" nxFormfieldSuffix></nx-datepicker-toggle>
                            <nx-datepicker #myDatepicker2></nx-datepicker>
                        </nx-formfield>
                    </div>

                    <div nxCol="12,12,6,6,6,6,6" *ngIf="isAmendDateScren">
                        <nx-formfield label="JPJ Status">
                            <input nxInput formControlName="jpjStatus" appToUpperCase />
                        </nx-formfield>
                    </div>
                </div>
            </div>
        </div>
    </nx-expansion-panel>
</nx-accordion>